/* eslint-disable */ 
import SessionService from '@/services/SessionService'
import LocalStorageService from '@/services/LocalStorageService'

export default {
  namespaced: true,
  state: {
    isRestored: false
  },
  getters: {
    isSameUser() {
      return localStorage.getItem('lastCodigoAccesso') === SessionService.getCodigoAccesso()
    }
  },
  mutations: {
    setIsRestored(state) {
      localStorage.setItem('lastCodigoAccesso', SessionService.getCodigoAccesso())
      state.isRestored = true
    },

    clear(state) {
      state.isRestored = false
    },

    connection(){}
  },
  actions: {
    // Called from router
    async restore({state, rootGetters, commit, dispatch}) {
      if (!state.isRestored) {
        try {
          await dispatch('parametro/checkIsTelefonoOperadorSet', null, {root:true})
          await dispatch('parametro/fetchListaPacientes', null, {root:true})
        } finally {
          commit('setIsRestored')
        }
      }
      if((rootGetters['parametro/getIsTelefonoSet'] || rootGetters['parametro/getRedirectedOnce']) && rootGetters['parametro/getHasPacientes']){
        commit('connection')
      }
    },

    async logout({commit, dispatch}) {
      localStorage.removeItem('lastCodigoAccesso')
      localStorage.removeItem('redirectedOnce');
      await dispatch('clear')
      commit('clear')
    },

    async clear() {
      // await dispatch('servicio/clear', null, {root:true})
      LocalStorageService.removeLastCuenta()
    },

    startConnection({commit}){
      commit('connection')
    }
  }
}
